import script from "./PWAInstallPrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./PWAInstallPrompt.vue?vue&type=script&setup=true&lang=ts"

import "./PWAInstallPrompt.vue?vue&type=style&index=0&id=3bf52e20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf52e20"]])

export default __exports__